import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie/es6';
import { SearchInsightsDocsBanner } from '@piplapps/pipl-ui';
import AnalyticsEventNames from '../../Utils/AnalyticsHandler/AnalyticsEventNames';
import AnalyticsCore from '../../Utils/AnalyticsHandler/AnalyticsCore';
import { AppSelectors } from '../../Redux/modules/app/selectors';
import AppConfig from '../../Config/AppConfig';

const SearchInsightsDocsBannerContainer = (props) => {
  const { user, tracking } = props;
  const SI_DOCUMENTATION_BANNER_DISABLED_BY_USER = 'si_documentation_banner_disabled_by_user';
  const [shouldShowDocsBanner, setShouldShowDocsBanner] = useState(true);
  const [cookies, setCookie] = useCookies([]);
  const { si_documentation_banner_timestamp: bannerTimestamp } = cookies;

  useEffect(() => {
    const deltaInSeconds = Date.now() / 1000 - parseInt(bannerTimestamp, 10);
    const maxTimeToDisplayInSeconds = 60 * 60 * 24 * parseInt(AppConfig.MAX_DAYS_TO_DISPLAY_SI_DOCS_BANNER, 10);

    const shouldShow = shouldShowDocsBanner && deltaInSeconds < maxTimeToDisplayInSeconds;

    setShouldShowDocsBanner(shouldShow);
  }, [shouldShowDocsBanner]);

  const buildEvent = (eventName) => AnalyticsCore.buildEvent({ user, tracking, eventName });

  return (
    <SearchInsightsDocsBanner
      isShowing={shouldShowDocsBanner}
      link={AppConfig.SI_DOCS_LINK}
      onClick={() => {
        const eventName = AnalyticsEventNames.SEARCH_INSIGHTS_DOCS_BANNER_CLICK;
        const trackingData = buildEvent(eventName);

        AnalyticsCore.sendEvent(trackingData);
      }}
      onClose={() => {
        setCookie(SI_DOCUMENTATION_BANNER_DISABLED_BY_USER, true, { path: '/' });
        setShouldShowDocsBanner(false);
        const eventName = AnalyticsEventNames.SEARCH_INSIGHTS_DOCS_BANNER_CLOSE;
        const trackingData = buildEvent(eventName);

        AnalyticsCore.sendEvent(trackingData);
      }}
    />
  );
};

SearchInsightsDocsBannerContainer.propTypes = {
  user: PropTypes.object,
  tracking: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    user: AppSelectors.userSelector(state),
    tracking: AppSelectors.trackingSelector(state),
  };
};

export default connect(mapStateToProps, null)(SearchInsightsDocsBannerContainer);
